export default {_name:'form.dynamic',module:'Field',view:'Element/Form/Dynamic',options:{events:{onChange:'persistChange'},xs:10,sm:8}}